


exports.createOpenItemSystem = ({$scope,soundsets})=>{

    let soundsetList = null
    soundsets.getSoundsets().then(newList => soundsetList = newList)

    const handleRequestOpenItem = ({soundsetId,elementId,moodId})=>{
        if(soundsetList === null){
            console.warn('soundset list still loading...');
            return
        }
        if(!soundsetId){
            console.warn('received message, but no soundset id specified...');
            return
        }
        //refreshing soundset list every go is agonizingly slow
        // const soundsetList = await	soundsets.getSoundsets()
        // const soundset = _.find(soundsetList, {id: soundsetId})
        const soundset = _.find(soundsetList, {id: soundsetId})
        if (!soundset){
            console.warn(`soundset with id ${soundsetId} not found`);
            return
        }

        $scope.select_soundset(soundset, true)
            .then(()=>{
            if ($scope.selected_soundset !== soundset){
                    console.warn(`user changed soundset, bailing...`);
                    return
                }
            if (moodId){
    
                const mood = _.find(soundset.moods, {pk: moodId})
                if (mood)
                    $scope.select_mood(mood)
                else
                    console.warn(`mood with id {moodId} not found`);
            }
            if (elementId) {
    
                const element = _.find(soundset.elements, {pk: elementId})
                if (element)
                    $scope.select_element(element)
                else
                    console.warn(`element with id {elementId} not found`);
            }

            $scope.force_apply();
        })

    }
    return {
        handleRequestOpenItem
    }
}




// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/openItemSystem.js